// Shared business-type constants used across Onboarding, AI Builder, and modules.

export const CATEGORY_GROUPS = {
  fast_food: { ar: 'وجبات سريعة', en: 'Fast Food', icon: '🍔', order: 1 },
  saudi_arabic: { ar: 'سعودي وعربي', en: 'Saudi & Arabic', icon: '🍚', order: 2 },
  international: { ar: 'مطابخ عالمية', en: 'International', icon: '🌍', order: 3 },
  beverages_desserts: { ar: 'مشروبات وحلويات', en: 'Drinks & Desserts', icon: '☕', order: 4 },
  modern_service: { ar: 'خدمات حديثة', en: 'Modern', icon: '🚀', order: 5 },
};

// Maps specific business types to their general template category.
// Anything not listed defaults to 'restaurant'.
const BUSINESS_TYPE_TEMPLATE_MAP = {
  specialty_coffee: 'cafe', fresh_juices: 'cafe', bubble_tea: 'cafe',
  ice_cream_gelato: 'cafe', donuts: 'cafe', waffle_pancake: 'cafe',
  chocolate_shop: 'cafe', cake_shop: 'cafe',
  food_truck: 'food_truck',
};

export const getTemplateCategory = (bt) =>
  BUSINESS_TYPE_TEMPLATE_MAP[bt] || 'restaurant';
